import { useRef, useState } from 'react'

import { getRequestsExtraInfo } from '../../../../../api'
import { EMPTY_LIST, EMPTY_OBJECT } from '../../../../../constants/common'
import { useIsMountedRef, useVariableRef } from '../../../../../hooks'
import { createSearchArray } from '../../../../../utils/api'
import { getItemsIds } from '../../../../../utils/common'
import { getRequestBoardItemRequestIds } from '../../RequestBoard.utils'

import {
  getRequestBoardExtraItems,
  getRequestBoardLatestExtraItems,
  mergeRequestBoardExtra,
} from './useRequestBoardExtra.utils'

export function useRequestBoardExtra({ filterValues }) {
  const [extra, setExtra] = useState({ filterValues, items: EMPTY_LIST })

  const requestIdRef = useRef(0)
  const itemRequestIdsRef = useRef(EMPTY_OBJECT)

  const filterValuesRef = useVariableRef(filterValues)

  const isMountedRef = useIsMountedRef()

  function handleLoadExtra(items) {
    if (items.length > 0 && isMountedRef.current) {
      requestIdRef.current += 1

      const requestId = requestIdRef.current

      itemRequestIdsRef.current = getRequestBoardItemRequestIds({
        ids: getItemsIds(items),
        requestId,
        requestIds: itemRequestIdsRef.current,
      })

      getRequestsExtraInfo(createSearchArray('id', items))
        .then(({ data }) => {
          const nextItems = getRequestBoardLatestExtraItems({
            items: data.items,
            requestId,
            requestIds: itemRequestIdsRef.current,
          })

          setExtra(prevExtra =>
            mergeRequestBoardExtra({
              filterValues: filterValuesRef.current,
              nextItems,
              prevExtra,
            })
          )
        })
        .catch(() => null)
    }
  }

  return {
    extra: { items: getRequestBoardExtraItems({ extra, filterValues }) },
    handleLoadExtra,
  }
}
